import {
  Amount,
  MilesPrice,
  OrderPaidAmount,
  OrderRefundAmounts,
  OrderUsedAmount,
} from '@dapi/sdk';
import {
  currency,
  inrCurrency,
  myRinggitCurrency,
  sekCurrency,
} from './currency';
import {
  paymentCardFee,
} from './fee';
import {
  multipleTaxes,
  multipleTaxesForAmop,
  multipleTaxesForMiles,
  multipleTaxesForVoucher,
  multipleTaxesForVoucher3,
  multipleTaxesWithMultipleVouchers,
  taxesForPaidAmount,
  taxesForPaidAmountWithMiles,
} from './tax';

export const baseAmount: Amount = {
  value: 1380,
  currencyCode: 'AED',
  currency
};

export const zeroAmountInSek: Amount = {
  value: 0,
  currency: sekCurrency,
  currencyCode: 'SEK'
};

export const zeroAmountInMYR: Amount = {
  value: 0,
  currencyCode: 'MYR',
  currency: myRinggitCurrency
};

export const zeroAmountInINR: Amount = {
  value: 0,
  currencyCode: 'INR',
  currency: inrCurrency
};

export const oneMillionRupees: Amount = {
  value: 1_000_000,
  currencyCode: 'INR',
  currency: inrCurrency
};

export const paidAmount: OrderPaidAmount = {
  base: baseAmount,
  taxes: multipleTaxes
};

export const refundAmounts: OrderRefundAmounts = {
  base: baseAmount,
  taxes: multipleTaxes,
  total: {
    ...baseAmount,
    value: 2345
  },
  totalTaxes: {
    ...baseAmount,
    value: 965
  }
};

export const usedAmount: OrderUsedAmount = {
  base: {
    ...baseAmount,
    value: 0
  }
};

export const arnEwrRefundAmount = {
  base: {
    value: 12_593,
    currencyCode: 'SEK',
    currency: sekCurrency
  },
  totalTaxes: {
    value: 1768,
    currencyCode: 'SEK',
    currency: sekCurrency
  },
  total: {
    value: 14_361,
    currencyCode: 'SEK',
    currency: sekCurrency
  }
};

export const amopPaidAmount = {
  base: {
    value: 172_600,
    currencyCode: 'MYR',
    currency: myRinggitCurrency
  },
  taxes: multipleTaxesForAmop
};

export const voucherPaidAmount = {
  base: {
    value: 610_000,
    currencyCode: 'INR',
    currency: inrCurrency
  },
  taxes: multipleTaxesForVoucher
};

export const voucherPaidAmountWithMultipleVouchers = {
  base: {
    value: 2_450_000,
    currencyCode: 'INR',
    currency: inrCurrency
  },
  taxes: multipleTaxesWithMultipleVouchers
};

export const voucherWithCCPaidAmount = {
  base: {
    value: 2_325_000,
    currencyCode: 'INR',
    currency: inrCurrency
  },
  taxes: multipleTaxesForVoucher3
};

export const amopRefundAmounts = {
  base: {
    value: 172_600,
    currencyCode: 'MYR',
    currency: myRinggitCurrency
  },
  taxes: multipleTaxesForAmop,
  totalTaxes: {
    value: 17_100,
    currencyCode: 'MYR',
    currency: myRinggitCurrency
  },
  total: {
    value: 189_700,
    currencyCode: 'MYR',
    currency: myRinggitCurrency
  }
};

export const voucherRefundAmounts = {
  base: {
    value: 610_000,
    currencyCode: 'INR',
    currency: inrCurrency
  },
  taxes: multipleTaxesForVoucher,
  totalTaxes: {
    value: 83_800,
    currencyCode: 'INR',
    currency: inrCurrency
  },
  total: {
    value: 431_300,
    currencyCode: 'INR',
    currency: inrCurrency
  }
};

export const cardRefundAmount = {
  base: {
    value: 12_593,
    currencyCode: 'INR',
    currency: inrCurrency
  },
  totalTaxes: {
    value: 1768,
    currencyCode: 'INR',
    currency: inrCurrency
  },
  total: {
    value: 14_361,
    currencyCode: 'INR',
    currency: inrCurrency
  }
};

export const cardRefundAmountWithObfees = {
  base: {
    value: 23_200,
    currencyCode: 'EUR',
    currency
  },
  fees: [{
    ...paymentCardFee,
    value: 1127
  }],
  taxes: taxesForPaidAmount,
  totalTaxes: {
    value: 15_015,
    currencyCode: 'EUR',
    currency
  },
  total: {
    value: 39_342,
    currencyCode: 'EUR',
    currency
  },
  totalFees: {
    value: 1127,
    currencyCode: 'EUR',
    currency
  }
};

export const voucherRefundAmountsWithMultipleVouchers = {
  base: {
    value: 2_450_000,
    currencyCode: 'INR',
    currency: inrCurrency
  },
  taxes: multipleTaxesWithMultipleVouchers,
  totalTaxes: {
    value: 348_500,
    currencyCode: 'INR',
    currency: inrCurrency
  },
  total: {
    value: 2_798_500,
    currencyCode: 'INR',
    currency: inrCurrency
  }
};

export const voucherWithCCRefundAmounts = {
  base: {
    value: 2_325_000,
    currencyCode: 'INR',
    currency: inrCurrency
  },
  taxes: multipleTaxesForVoucher3,
  totalTaxes: {
    value: 333_500,
    currencyCode: 'INR',
    currency: inrCurrency
  },
  total: {
    value: 2_266_500,
    currencyCode: 'INR',
    currency: inrCurrency
  }
};

export const voucherPenaltyAmount = {
  value: 262_500,
  currencyCode: 'INR',
  currency: inrCurrency
};

export const voucherPenaltyAmount2 = {
  value: 896_300,
  currencyCode: 'INR',
  currency: inrCurrency
};

export const voucherWithCCPenaltyAmount = {
  value: 392_000,
  currencyCode: 'INR',
  currency: inrCurrency
};

export const penaltyAmount: Amount = {
  ...zeroAmountInSek,
  value: 17_246
};

export const mockMilesPrice: MilesPrice = {
  baseFare: {
    currencyType: 'LOYALTY_REWARD',
    amount: '31600',
    value: 31_600,
    decimalPlaces: 0,
    priceQualifier: 'BASE_FARE'
  },
  totalFare: {
    currencyType: 'LOYALTY_REWARD',
    amount: '31600',
    value: 31_600,
    decimalPlaces: 0,
    priceQualifier: 'TOTAL_FARE'
  },
  totalTaxes: {
    currencyType: 'LOYALTY_REWARD',
    amount: '0',
    value: 0,
    decimalPlaces: 0,
    priceQualifier: 'TOTAL_TAX'
  }
};

export const mockMilesPriceWithoutCancellation: MilesPrice = {
  baseFare: {
    ...mockMilesPrice.baseFare,
    amount: '19000',
    value: 19_000
  },
  totalFare: {
    ...mockMilesPrice.totalFare,
    amount: '19000',
    value: 19_000
  },
  totalTaxes: {
    ...mockMilesPrice.totalTaxes
  }
};

export const refundAmountsWithMiles: OrderRefundAmounts = {
  base: zeroAmountInSek,
  totalTaxes: {
    ...zeroAmountInSek,
    value: 5686
  },
  total: {
    ...zeroAmountInSek,
    value: 5686
  },
  milesPrice: mockMilesPrice
};

export const refundAmountsWithMilesWithoutCancellation: OrderRefundAmounts = {
  base: zeroAmountInSek,
  totalTaxes: {
    ...zeroAmountInSek,
    value: 5825
  },
  total: {
    ...zeroAmountInSek,
    value: 5825
  },
  taxes: multipleTaxesForMiles,
  milesPrice: mockMilesPriceWithoutCancellation
};

export const refundAmountsWithMilesZeroWithoutCancellation: OrderRefundAmounts = {
  ...refundAmountsWithMilesWithoutCancellation,
  milesPrice: undefined
};

export const paidAmountWithMiles: OrderPaidAmount = {
  base: zeroAmountInSek,
  taxes: taxesForPaidAmountWithMiles,
  milesPrice: {
    baseFare: mockMilesPrice.baseFare
  }
};

export const paidAmountWithMilesWithoutCancellation: OrderPaidAmount = {
  base: zeroAmountInSek,
  taxes: multipleTaxesForMiles,
  milesPrice: {
    baseFare: mockMilesPriceWithoutCancellation.baseFare
  }
};

export const paidAmountWithOBFees: OrderPaidAmount = {
  base: {
    ...zeroAmountInSek,
    value: 23_200
  },
  fees: [{
    ...paymentCardFee,
    value: 1127
  }],
  taxes: taxesForPaidAmount
};

export const paidAmountWithZeroMilesWithoutCancellation: OrderPaidAmount = {
  ...paidAmountWithMilesWithoutCancellation,
  milesPrice: undefined
};

export const usedAmountWithMiles: OrderUsedAmount = {
  base: zeroAmountInSek,
  milesPrice: {
    baseFare: {
      ...mockMilesPrice.baseFare,
      amount: '0',
      value: 0
    }
  }
};

export const usedAmountWithZeroMiles: OrderUsedAmount = {
  ...usedAmountWithMiles,
  milesPrice: undefined
};

export const zeroBaseAmount: OrderUsedAmount = {
  base: {
    value: 0,
    currencyCode: 'EUR',
    currency
  }
};
